export interface SupportMeetingActivities {
  supportMeetingID: string;
  supportMeetingActivitiesCount?: number;
}

export * from './support-meeting-activities-dialog';
export * from './support-meeting-activities-grid-config';
export * from './support-meeting-activities-editor';
